const config = {
    env: process.env.REACT_APP_STAGE || 'local',
    api: {
        baseUrl: 'https://ecdataanalysis.bigdataghana.com/api',
        // baseUrl: ' http://127.0.0.1:8000/api',
        // baseUrl: "https://asaaseradio-ecanalysis.bigdataghana.com/api",
        endpoints: {
            login: '/auth/login',
            officers:'/officers',
            constituencies:'/constituency',
            assign_constituencies:'/rbac/assign_constituencies',
            assigned_constituencies: '/rbac/assigned_constituencies',
            results_by_election_type: "/result/by-election-type",
            results_by_const_code:"/result/by-const-code",
            results: '/result',
            parties: '/political-party',
            

            // Add other endpoints here
        },
    },
};

export default config;